/**
 * Incidents Selectors
 */
export const selectDrawerIncident = (state) => state.incidents.drawerIncident;
export const selectLoadedIncidents = (state) => state.incidents.loadedResults;
export const selectResetIncidents = (state) => state.incidents.reset;
export const selectSettingsDisabled = (state) =>
  state.incidents.settingsDisabled;
export const selectIncidentTotalRows = (state) => state.incidents.totalRows;
export const selectIncidentsLoading = (state) => state.incidents.loading;
export const selectIncidentSearchText = (state) => state.incidents.searchText;
export const selectTotalIncidentsCount = (state) => state.incidents.totalCount;
export const selectNewIncidentsCount = (state) => state.incidents.totalNewCount;
export const selectOpenIncidentsCount = (state) =>
  state.incidents.totalOpenCount;
export const selectUnassignedIncidentsCount = (state) =>
  state.incidents.totalUnassignedCount;
export const selectIncidentZeroResults = (state) =>
  state.incidents.hasZeroResults;
